// Components
import React from 'react';
import Typography from '@mui/material/Typography';

// Components
import Button from '../../Button';

// Hooks
import use2Modal from '../../../hooks/use2Modal';
import Feather from '../../Feather';
import useUser from '../../../hooks/useUser';

// Styles
import { useStyles } from './SavedInfoCardStyles';

const SavedInfoCard = ({ message, btnTitle }) => {
  const { classes } = useStyles();
  const { onClose } = use2Modal();
  const { isKiteUser } = useUser();

  return (
    <div className={classes.root}>
      <div className={classes.icon}>
        <Feather nativeColor={!isKiteUser} printType="stroke" type="success" />
      </div>
      <Typography className={classes.message} variant="h2">
        {message}
      </Typography>
      <Button className={classes.button} onClick={onClose}>
        {btnTitle}
      </Button>
    </div>
  );
};

export default SavedInfoCard;
